module.exports = __webpack_public_path__ + "img/customer-a-018.be19015f.png";